import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TicketCategory1 } from '@work4all/models/lib/Classes/TicketCategory1.entity';

import { IFilterPickerConfig } from '../../../../components/entity-picker/components/list-entity-picker';
import { TicketCategory1Picker } from '../../../../components/entity-picker/TicketCategory1Picker';
import { FilterCard } from '../filter-card/FilterCard';

export type ITicketCategory1FilterCardProps = {
  title: string;
  value: TicketCategory1[] | null;
  onChange: (value: TicketCategory1[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
  filterConfig?: IFilterPickerConfig;
};

export function TicketCategory1FilterCard(
  props: ITicketCategory1FilterCardProps
) {
  const { title, value, onChange, expanded, onExpandedChange, filterConfig } =
    props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value || value.length === 0) return null;

    return value.length + ' ' + t('COMMON.CHOSEN');
  }, [value, t]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <TicketCategory1Picker
        layout="advanced"
        multiple={true}
        value={value}
        onChange={(newValue) => {
          onChange(newValue);
        }}
        filterConfig={filterConfig}
      />
    </FilterCard>
  );
}
